<template>
  <div class="field has-addons">
    <div class="form-group control has-icons-right">
      <input
        id="discountCode"
        v-model="discountCode"
        type="text"
        class="input"
        required
      />
      <label class="form-control-placeholder" for="discountCode">
        Discount code
      </label>
      <span
        v-if="discountType === 'code'"
        class="icon is-success is-small is-right"
      >
        <font-awesome-icon :icon="['far', 'check-circle']" />
      </span>
      <span :class="{ 'is-danger': discountError }" class="help">{{
        discountError
      }}</span>
      <span v-if="discountType === 'code'" class="">
        Discount applied {{ discount }} %
      </span>
    </div>
    <div class="control">
      <a
        :class="{ 'is-loading': discountLoading }"
        class="button ps-button"
        @click="applyCodeDiscount(discountCode)"
      >
        Apply Discount
      </a>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ApplyDiscountCode',
  data: () => {
    return {
      discountCode: '',
    }
  },
  computed: {
    ...mapGetters({
      discountType: 'quote/discountType',
      discount: 'quote/discount',
      discountError: 'quote/discountError',
    }),
    discountLoading() {
      return this.$store.getters['quote/isDiscountLoading']
    },
  },
  created() {},
  methods: {
    ...mapActions('quote', {
      applyCodeDiscount: 'getCodeDiscount',
    }),
  },
}
</script>

<style lang="scss" scoped>
.fullwidth {
  width: 100%;
}
.discount {
  padding-bottom: 5px;
  span {
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>

<style lang="scss" scoped></style>
